import React, {useContext} from "react";
import {ClientContext} from "./ClientView";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {shortDateFormat} from "../../../../../util/DateTimeUtils";
import {fullName} from "../../../../../util/BookingUtil";
import {LoadingDots} from "../../../../../util/UI/LoadingDots";
import {formatPhoneNumber} from "react-phone-number-input";

export const ClientProfile = () => {

  const {client, rpcState} = useContext(ClientContext);

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={`Client: ${fullName(client?.user)}`}
                      buttons={[{text: 'Back to Clients', link: '../../', isSecondary: true}]}
                      tabs={[
                        {label: 'Profile', link: '.', isSelected: true},
                        {label: 'Bookings', link: './bookings'},
                        {label: 'Payments', link: './transactions'},
                      ]}
    />

    <div className={'ProviderToolAreaContent'}>


      {rpcState.state == 'pending' && <div>Loading<LoadingDots/></div>}
      {rpcState.state == 'error' && <div className={'ErrorText'}>{rpcState.message}</div>}
      {rpcState.state == 'success' && <>

        <h2>Client profile</h2>
        <div>Name: <b>{fullName(client?.user)}</b></div>
        <div>Contact email: <b>{client?.user?.contactEmail}</b></div>
        <div>Phone: <b>{client?.user?.mobileNumber ? formatPhoneNumber(client.user.mobileNumber) : ''}</b></div>
        <div>Client since: <b>{shortDateFormat(new Date(client?.relationship?.createdTimestampMs as number))}</b></div>

        <h2>Class credits</h2>
      {client?.relationship?.singleClassCredits?.map((credit, i) => {
        return <div key={'credit-' + i}>
          <b>{credit.classDetails?.className || credit.serviceDetails?.serviceName || credit.priceCategoryDetails?.displayName}.</b>&nbsp;
          Purchased {shortDateFormat(new Date(credit.purchaseTimestamp as number))}&nbsp;
          {credit.used ? <span className={'YellowHighlight'}>Used</span> :
              <span className={'GreenHighlight'}>Unused</span>}
        </div>;
      })}
        {!client?.relationship?.singleClassCredits?.length && <>None found</>}

        <h2>Packages</h2>
        {client?.relationship?.purchasedClassPacks?.map((pack, i) => {
          return <div key={'credit-' + i}>
            <b>{pack.packageDetails?.displayName}.</b>&nbsp;
            Purchased {shortDateFormat(new Date(pack.purchaseTimestamp as number))}.&nbsp;
            Classes remaining:&nbsp;
            {pack.classesRemaining == 0 ? <span className={'YellowHighlight'}>None</span> :
                <span className={'GreenHighlight'}>{pack.classesRemaining}</span>}
          </div>;
        })}
        {!client?.relationship?.purchasedClassPacks?.length && <>None found</>}
      </>}
    </div>
  </div>
}